<template>
  <section>
    <h2 class="h2Title">회원 정보</h2>
    <div class="dashWrap">
      <div class="dashRow">
        <div class="dashBx">
          <v-tabs>
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#tab-1">
              <v-icon>mdi-account</v-icon>
              {{ title }}
            </v-tab>

            <v-tab href="#tab-2" :disabled="!isModify">
              <v-icon>mdi-currency-krw</v-icon>
              회비납부정보
            </v-tab>
            <v-tab href="#tab-3" :disabled="!isModify">
              <v-icon>mdi-receipt</v-icon>
              모임신청정보
            </v-tab>

            <v-tab-item value="tab-1" key="1">
              <h2 class="tit arrowLink d-flex align-center justify-space-between">
              </h2>

              <div class="formInfo">
                <v-form ref="formUser">
                  <dl class="infoCont">
                    <dd class="formInfoArea d-flex">
                      <v-col class="mgr" sm="3">
                        <vue-dropzone
                            ref="userPhotoDropzone"
                            id="dropzone"
                            :options="dropzoneOptions"
                            :useCustomSlot="true"
                            @vdropzone-success="photoUploadSuccess"
                            @vdropzone-removed-file="photoRemove"

                        >

                          <div v-if="user.photoFile" style="margin-top: -40px">
                            <v-badge
                                bordered
                                dark
                                color="black"
                                icon="mdi-delete"
                                overlap
                                @click.native="photoRemove"
                            >
                              <img :src="`${attachFileServerUrl}/user/photo/${user.photoFile}`" style="max-height: 240px; max-width: 220px"/>
                            </v-badge>
                          </div>
                          <div class="dropzone-custom-content" v-else>
                            <h3 class="dropzone-custom-title">회원 사진</h3>
                            <div class="subtitle">Drag and drop or click to select a file from your computer</div>
                          </div>
                        </vue-dropzone>
                      </v-col>
                      <v-col class="mgr">
                        <v-row>
                          <v-col class="d-flex">
                            <v-text-field v-model="user.name" label="회원명" :rules="[rules.required]" flat dense></v-text-field>
                            <v-switch v-model="user.staff" :label="user.staff ? 'STAFF' : '회원'" class="staff-switch-color" style="padding-left:15px; padding-top: 10px; padding-right:15px;"></v-switch>
                          </v-col>
                          <v-col class="d-flex">
                              <v-text-field v-model="user.userId" label="아이디" :rules="[rules.required]" flat dense :readonly="idReadOnly" :error-messages="errorMessages" :filled="idReadOnly" :style="idReadOnly ? 'margin-top: -11px' : 'margin-top: 0px'"></v-text-field>
                              <v-btn class="vBtn" color="warning" dark v-if="isModify" @click="() => idReadOnly = !idReadOnly">아이디 변경</v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="d-flex">
                              <v-menu
                                  ref="birthPicker"
                                  v-model="birthPicker"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                      v-model="user.birthDate"
                                      prepend-icon="mdi-calendar"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      label="생년월일"
                                      dense
                                      flat
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                    ref="picker"
                                    v-model="user.birthDate"
                                    :max="new Date().toISOString().substr(0, 10)"
                                    min="1930-01-01"
                                    @change="datePick"
                                    locale="ko-kr"
                                ></v-date-picker>
                              </v-menu>
                              <v-switch v-model="user.lunarBirth" :label="user.lunarBirth ? '음력' : '양력'" class="lunar-switch-color" style="padding-left:15px; padding-top: 10px; padding-right:15px;"></v-switch>
                          </v-col>
                          <v-col>
                              <v-text-field v-model="user.mobileNo" type="number" maxlength="11" :rules="[rules.required]"  dense flat label="연락처" :error-messages="errorMessagesMobile"/>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="wh300">
                            <v-text-field
                                v-model="user.password"
                                label="패스워드"
                                :type="passwordShow ? 'text' : 'password'"
                                :rules="[passwordRequired]"
                                :append-icon="passwordShow? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="passwordShow = !passwordShow"
                                dense flat/>
                          </v-col>
                          <v-col class="wh300">
                            <v-text-field
                                v-model="passwordCheck"
                                label="패스워드 확인"
                                :type="passwordCompareShow ? 'text' : 'password'"
                                :rules="[passwordRequired, passwordCompare]"
                                :append-icon="passwordCompareShow? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="passwordCompareShow = !passwordCompareShow"
                                dense flat/>
                          </v-col>
                        </v-row>

                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">승인 분과 / 승인 동호회</dt>
                    <dd class="formInfoArea">
                      <v-col class="d-flex">
                        <a @click="groupSetting" v-if="user.userHasGroups && user.userHasGroups.findIndex(e => e.state === 'STATE_REQUEST') ===  -1">분과 / 동호회 설정</a>
                        <a @click="groupSetting" v-else>대기중</a>

                        <ul>
                          {{computedDepartment.groupName}}
                        </ul>
                        <ul>
                        /
                        </ul>
                        <ul v-for="(group) in computedClubs" :key="group.groupId">
                          {{group.groupName}}
                        </ul>
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">주소 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col class="d-flex">
                        <v-text-field type="number" v-model="user.zipCode" label="우편번호"
                                      @click="openZipCode"
                                      v-on:keyup.13="openZipCode"
                                      maxlength="6"
                                      :rules="[
                                              rules.required,
                                              value => !!value && value.length >= 5 && value.length <= 6 || '우편번호 형식이 아닙니다.\n\r5~6자리 숫자로 입력해주세요.'
                                              ]"
                                      style="max-width: 100px"
                        />
                        <v-text-field v-model="user.address" :rules="[rules.required]" label="주소"/>
                        <v-text-field v-model="user.addressDetail" label="주소상세"/>
                        <v-dialog v-model="daumDialogVisible" max-width="500px" @click:outside="daumDialogVisible=false" @keydown.esc="daumDialogVisible=false">
                          <daum-post @complete="completeZipCode" />
                        </v-dialog>
                      </v-col>
                    </dd>
                  </dl>

                  <dl class="infoCont">
                    <dt class="formInfoTxt">이메일 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col>
                        <v-text-field v-model="user.email" :rules="[rules.emeailRules]" dense flat :error-messages="errorMessagesEmail"/>
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">현재 직장</dt>
                    <dd class="formInfoArea">
                      <v-col>
                        <v-text-field v-model="user.company" dense flat />
                      </v-col>
                    </dd>
                    <dt class="formInfoTxt">현재 직책</dt>
                    <dd class="formInfoArea">
                      <v-col>
                        <v-text-field v-model="user.position" dense flat />
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">최종부서 (전자 재임시) <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col>
                        <v-text-field v-model="user.retirementDepartment" :rules="[rules.required]"  dense flat />
                      </v-col>
                    </dd>
                    <dt class="formInfoTxt">직위 (전자 재임시) <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col>
                        <v-text-field v-model="user.retirementPosition" :rules="[rules.required]" dense flat />
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">퇴임일 및 전출일 </dt>
                    <dd class="formInfoArea">
                      <v-col>
                        <v-text-field v-model="user.retirementDate"  dense flat />
                      </v-col>
                    </dd>
                    <dt class="formInfoTxt">수신 동의 여부</dt>
                    <dd class="formInfoArea">
                      <v-col class="d-flex">
                        <v-switch v-model="user.isMailReceive" label="이메일 수신 동의" :value="true" :false-value="false" style="padding-right: 20px"/>
                        <v-switch v-model="user.isSmsReceive" label="sms 수신 동의" :value="true" :false-value="false"  style="padding-right: 20px"/>
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">이력</dt>
                    <dd class="formInfoArea">
                        <v-textarea v-model="user.career" dense flat />
                    </dd>
                    <dt class="formInfoTxt">메모</dt>
                    <dd class="formInfoArea">
                      <v-textarea v-model="user.memo" dense flat />
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">역할 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col>
                        <v-select :items="roles" item-value="roleId" item-text="roleName" v-model="user.userHasRoles"
                                  clearable dense flat required :rules="[rules.required]" multiple/>
                      </v-col>
                    </dd>
                    <dt class="formInfoTxt">상태 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                    <dd class="formInfoArea">
                      <v-col>
                        <v-select :items="states" item-value="value" item-text="text" v-model="user.state"
                                  :rules="[rules.required]"
                                  clearable dense flat required />
                      </v-col>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">약관 동의 여부</dt>
                    <dd class="formInfoArea">
                      <v-col class="d-flex">
                        <v-switch v-model="user.antiGraftLawTarget" label="청탁금지법 대상" :value="true" :false-value="false" style="padding-right: 20px"/>
                        <v-switch v-model="user.clauseAgreement" label="약관 동의 여부" :value="true" :false-value="false"  style="padding-right: 20px"/>
                        <v-switch v-model="user.personalInformationAgreement" label="개인정보 수집 및 이용에 동의" :value="true" :false-value="false" />
                      </v-col>
                    </dd>
                    <dt class="formInfoTxt">승인 및 가입일시</dt>
                    <dd class="formInfoArea">
                      <div>
                        <div>
                          승인일시 / {{user.approvedAt | moment('YYYY-MM-DD')}}
                        </div>
                        <div class="joinDate">
                          <div class="joinDateHelper"/>                          
                          <div class="joinDate_item" style="width:60px">
                          가입일시 / <span>&nbsp;&nbsp;</span>
                          </div>
                          <div class="joinDate_item" style="width:90px">
                          <v-menu
                            ref = "joinPicker"
                            v-model="joinPicker"
                            :close-on-content-click="false"
                            :nudge-right="170"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="joinDate"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                color="white"
                                append-outer-icon="mdi-calendar"
                                :disabled="joinEdit"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="joinDate"
                              @input="joinPicker = false"
                            ></v-date-picker>
                          </v-menu>
                          </div>
                          <span v-if="user.mobileJoined">(<b>모바일 가입 회원</b>)</span>
                          <v-btn style="margin-left:10px"
                          depressed
                          rounded
                          small
                          color="warning"
                          @click="dateEdit()"
                          >가입일시 변경</v-btn>
                        </div>
                      </div>
                    </dd>
                  </dl>
                  <dl class="infoCont">
                    <dt class="formInfoTxt">알림 설정</dt>
                    <dd class="formInfoArea">
                      <v-col class="d-flex">
                        <v-switch v-model="notifyAll" label="전체 알림" :value="true" :false-value="false" style="padding-right: 20px"/>
                        <v-switch v-model="user.notifyAllowed" label="알림 허용" :value="true" :false-value="false" style="padding-right: 20px"/>
                        <v-switch v-model="user.notifyComment" label="댓글 알림" :value="true" :false-value="false" style="padding-right: 20px"/>
                        <v-switch v-model="user.notifyNotice" label="공지 알림" :value="true" :false-value="false" style="padding-right: 20px"/>
                        <v-switch v-model="user.notifyEvent" label="행사 알림" :value="true" :false-value="false" style="padding-right: 20px"/>
                        <v-switch v-model="user.notifyDepartment" label="내 분과 알림" :value="true" :false-value="false" style="padding-right: 20px"/>
                        <v-switch v-model="user.notifyClub" label="내 동호회 알림" :value="true" :false-value="false" style="padding-right: 20px"/>
                        <v-switch v-model="user.notifyNote" label="쪽지 알림" :value="true" :false-value="false" style="padding-right: 20px"/>
                        <v-switch v-model="user.notifyCc" label="경조사 알림" :value="true" :false-value="false" style="padding-right: 20px"/>
                        <v-switch v-model="user.notifyHypermeeting" label="화상회의 알림" :value="true" :false-value="false" style="padding-right: 20px"/>
                      </v-col>
                    </dd>
                  </dl>
                </v-form>
              </div>
              <div class="btnStyleBx">
                <div class="btnCommon justify-center">
                  <v-btn class="vBtn" color="primary" dark @click="saveUser()">
                    <v-icon left>mdi mdi-check</v-icon>
                    저장
                  </v-btn>
                  <v-btn class="vBtn" color="grey" dark @click="resetUser">
                    <v-icon left>mdi mdi-reload</v-icon>
                    취소
                  </v-btn>
                  <a @click="$router.go(-1)">
                  <v-btn class="vBtn" color="#fafafa">
                    <v-icon left>mdi mdi-format-list-bulleted</v-icon>
                    목록
                  </v-btn>
                  </a>
                </div>
              </div>

            </v-tab-item>
            <v-tab-item value="tab-2" key="2">
              <h2 class="tit arrowLink d-flex align-center justify-space-between">
              </h2>
              <dues-list :user-id="user.userId"/>
              <div class="btnStyleBx">
                <div class="btnCommon justify-center">
                  <a @click="$router.go(-1)">
                    <v-btn class="vBtn" color="#fafafa">
                      <v-icon left>mdi mdi-format-list-bulleted</v-icon>
                      회원 목록
                    </v-btn>
                  </a>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item value="tab-3" key="3">
              <h2 class="tit arrowLink d-flex align-center justify-space-between">
              </h2>
              <meeting-list :user-id="user.userId"/>
              <div class="btnStyleBx">
                <div class="btnCommon justify-center">
                  <a @click="$router.go(-1)">
                    <v-btn class="vBtn" color="#fafafa">
                      <v-icon left>mdi mdi-format-list-bulleted</v-icon>
                      회원 목록
                    </v-btn>
                  </a>
                </div>
              </div>
            </v-tab-item>
          </v-tabs>

        </div>
      </div>
    </div>
    <user-group
      :is-visible="groupDialogVisible"
      :item="userCopy"
      @callback-cancel="groupDialogVisible = false"
      @callback-changed="changedUserGroupState"
      @callback-appended="addGroup"
      @callback-deleted="deleteGroup"
  />
  </section>
</template>
<script>
import userApi from "@/api/UserApi";
import roleApi from '@/api/RoleApi'
import groupApi from "@/api/GroupApi";

import UserGroup from "./UserGroup";
import DuesList from "./Dues";
import MeetingList from "./Meeting";
 
import _ from 'lodash';
import vue2Dropzone from 'vue2-dropzone'
// import { VueDaumPostcode } from "vue-daum-postcode"

export default {
  name: "UserForm",
  components: {
    vueDropzone: vue2Dropzone,
    'user-group': UserGroup,
    'dues-list' : DuesList,
    'meeting-list' : MeetingList,
    // VueDaumPostcode,
  },
  props: {
    userId: String
    // item: Object
  },
  watch: {
    birthPicker (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    
  },
  data: () => ({
    idReadOnly: false,
    daumDialogVisible: false,
    groupDialogVisible: false,
    birthPicker: false,
    joinPicker :false,
    joinDate:null,
    joinAt:null,
    joinEdit:true,
    attachFileServerUrl: process.env.VUE_APP_ATTACH_FILE_SERVER_URL,
    passwordShow: false,
    passwordCompareShow: false,
    user: {
      zipCode:'',
      address:'',
      lunarBirth: false,
      birthDate: '1960-01-01',
      antiGraftLawTarget: false,
      clauseAgreement: false,
      personalInformationAgreement: false
    },
    userCopy: {

    },
    userInit: {

    },
    approvalDepartment:null,
    approvalClubs:[],
    groups:[],
    csvData:'',
    csvFile:null,
    title:'회원 추가',
    departmentItems:[],
    clubItems:[],
    roles:[],
    rules: {
      required: value => (value && value.length > 0) || '필수 입력 항목입니다..',
      // length11: value => value && value.length < 12 || '11자리 이하 숫자로만 입력 가능합니다..',
      emeailRules: value => (new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(value)&&!value.includes(',')) || '이메일 형식이 아닙니다.',
    },
    passwordCheck:'',
    isModify:false,
    errorMessages:'',
    errorMessagesMobile:'',
    errorMessagesEmail:'',
    states:[
      {text: '승인', value: 'STATE_NORMAL'},
      {text: '대기', value: 'STATE_REQUEST'},
      {text: '심사중', value: 'STATE_EXAMINATION'},
      {text: '반려', value: 'STATE_REJECT'},
      {text: '탈퇴', value: 'STATE_WITHDRAW'},
      {text: '탈퇴대기', value: 'STATE_WITHDRAW_REQUEST'},
      {text: '휴면', value: 'STATE_DORMANT'},
      {text: '차단', value: 'STATE_BLOCKED'},
    ],
    departmentMeta:null,
    clubMeta:null
  }),
  computed: {
    notifyAll: {
      get() {
        return this.user.notifyAllowed && this.user.notifyComment && this.user.notifyNotice && this.user.notifyEvent && this.user.notifyDepartment && this.user.notifyClub && this.user.notifyNote && this.user.notifyCc && this.user.notifyHypermeeting
      },
      set(v) {
        if(v) {
          this.user.notifyAllowed = this.user.notifyComment = this.user.notifyNotice = this.user.notifyEvent = this.user.notifyDepartment = this.user.notifyClub = this.user.notifyNote = this.user.notifyCc = this.user.notifyHypermeeting = true;
        } else if(this.user.notifyComment && this.user.notifyNotice && this.user.notifyEvent && this.user.notifyDepartment && this.user.notifyClub && this.user.notifyNote) {
          this.user.notifyAllowed = this.user.notifyComment = this.user.notifyNotice = this.user.notifyEvent = this.user.notifyDepartment = this.user.notifyClub = this.user.notifyNote = this.user.notifyCc = this.user.notifyHypermeeting = false;
        }
      },
    },
    dropzoneOptions() { 
      return {
        url: `${process.env.VUE_APP_BASE_API}/user/upload/image`,
        thumbnailWidth: 150,
        maxFilesize: 2, // mb
        maxFiles: 2,
        acceptedFileTypes: "image/*",
        headers: {
          'Authorization': `bearer ${this?.$store?.getters?.token ?? ''}` 
        },
        uploadMultiple: false,
        clickable: true,
        addRemoveLinks: true
      }
    },
    passwordCompare() {
      return () => (this.user.password === this.passwordCheck) || '패스워드가 일치하지 않습니다.'
    },
    passwordRequired() {
      return value => (!!value || this.isModify) || '필수 입력 항목입니다..'
    },
    computedClubs() {
      return this.clubItems?.filter(c => this.approvalClubs.includes(c.groupId));
    },
    computedDepartment() {
      return this.departmentItems?.filter(c => this.approvalDepartment === c.groupId)[0]??{};
    }
  },
  methods: {
    dateEdit(){
      this.joinEdit=!this.joinEdit;
    },
    changedUserGroupState(groupId, state, groupType) {

      if(state === 'STATE_APPROVAL') {
        if(groupType === 'club')
          this.approvalClubs = Array.from(new Set([...this.approvalClubs, groupId]));
        else
          this.approvalDepartment = groupId;

      } else {
        if (groupType === 'club')
          this.approvalClubs = this.approvalClubs.filter(c => c !== groupId);
        else
          this.approvalDepartment = null;
      }

      if(groupType === 'club') {
        this.user.clubGroup = this.user.clubGroup.map(g => {

          if(g.groupId === groupId) {
            return {
              groupId,
              groupName: this.clubItems.filter(g => g.groupId === groupId)[0].groupName,
              joinState: state
            }
          }

          return g
        });

      } else {
        this.user.departmentGroup = [{
          groupId,
          groupName: this.departmentItems.filter(g => g.groupId === groupId)[0].groupName,
          joinState: state
        }];
      }

      this.user.userHasGroups = this.user.userHasGroups.map(g => {
          if(g.id.groupId === groupId) {
            g.state = state;
            g.stateChangedAt = null;
          }

          return g;
      });
    },
    addGroup(groupId, isDepartment) {

      this.user.userHasGroups = [...this.user?.userHasGroups?.filter(g => g.id.groupId !== groupId)??[], {
        id: {groupId:groupId},
        state: 'STATE_REQUEST'
      }];

      if(isDepartment) {

        this.user.userHasGroups = this.user?.userHasGroups?.filter(g => g.id.groupId === groupId || (this.user.clubGroup?.map(c => c.groupId)??[]).includes(g.id.groupId))??[];

        this.approvalDepartment = null;
        this.user.departmentGroup = [{
          groupId,
          groupName: this.departmentItems?.filter(g => g.groupId === groupId)?.[0]?.groupName??'',
          joinState: 'STATE_REQUEST'
        }];

      } else {

        this.user.clubGroup = [...this.user.clubGroup??[] , {
          groupId,
          groupName: this.clubItems?.filter(g => g.groupId === groupId)?.[0]?.groupName??'',
          joinState: 'STATE_REQUEST'
        }];

      }

    },
    deleteGroup(groupId) {
      this.approvalClubs = this.approvalClubs?.filter(id => id !== groupId)??[];
      this.approvalDepartment = this.approvalDepartment === groupId ? null : this.approvalDepartment;
      this.user.userHasGroups = this.user?.userHasGroups?.filter(g => g.id.groupId !== groupId)??[];

      this.user.departmentGroup = this.user?.departmentGroup?.filter(g => g.groupId !== groupId)??[];
      this.user.clubGroup = this.user?.clubGroup?.filter(g => g.groupId !== groupId)??[];
    },
    groupSetting() {
      this.userCopy = _.cloneDeep(this.user);
      this.groupDialogVisible = true;
    },
    datePick(date) {
      this.$refs.birthPicker.save(date)
    },
    photoUploadSuccess(file, response) {
      this.user.photoFile = response.saveName;
      const acceptedFiles = this.$refs.userPhotoDropzone.getAcceptedFiles();
      if(acceptedFiles && acceptedFiles.length > 1)
        this.$refs.userPhotoDropzone.removeFile(acceptedFiles[0]);
    },
    photoRemove() {
      // console.log(this.user.photoFile);
      this.user.photoFile = null;
      // console.log(this.user.photoFile);
    },
    openZipCode() {
      // let _user = this.user;
      this.daumDialogVisible = true;
      // eslint-disable-next-line no-undef
      // new daum.Postcode({
      //   oncomplete: function(data) {
      //     _user.zipCode = data.zonecode;
      //     _user.address = data.address;
      //   }}).open();
    },
    completeZipCode(data) {
      this.user.zipCode = data.zonecode
      this.user.address = data.address
      this.daumDialogVisible = false;
    },
    async duplicatedUserIdCheck(userId) {
      if(userId) {
        const isUsed = await userApi.exists(userId)
        if (isUsed && (!this.isModify || (!this.idReadOnly && this.user.originUserId !== userId))) {
          this.errorMessages = '이미 사용중인 아이디입니다.';
          return false;
        }
        this.errorMessages = null;
        return true;
      }

      return false;
    },
    async duplicatedMobileNoCheck(mobileNo) {
      if(mobileNo) {
        const isUsed = await userApi.existsMobile(mobileNo)
        if (isUsed && !this.isModify) {
          this.errorMessagesMobile = '이미 등록된 연락처입니다.';
          return false;
        }
        this.errorMessagesMobile = null;
        return true;
      }

      return false;
    },
    async duplicatedEmailCheck(email) {
      if(email) {
        const isUsed = await userApi.existsEmail(email)
        if (isUsed && !this.isModify) {
          this.errorMessagesEmail = '이미 등록된 이메일입니다.';
          return false;
        }
        this.errorMessagesEmail = null;
        return true;
      }

      return false;
    },
    async saveUser() {
      const valid = [await this.$refs.formUser.validate(), await this.duplicatedUserIdCheck(this.user.userId), await this.duplicatedMobileNoCheck(this.user.mobileNo), await this.duplicatedEmailCheck(this.user.email)];
      if(valid.indexOf(false) !== -1) {
        window.scrollTo(0,50);
        alert("입력 폼 유효성 검증에 실패했습니다. 입력 항목을 확인해주세요.")
        return;
      }
      try {
        this.user.userHasGroupObjects = _.cloneDeep(this.user.userHasGroups);
        delete this.user.userHasGroups;

        // 아이디 모든 공백 제거
        this.user.userId = this.user.userId.replace(/(\s*)/g, "");
        this.user.createdAt = this.joinAt !=null ? this.joinAt.replace(this.joinAt.substr(0,10),this.joinDate):null;
        userApi.save(this.user).then(() => {
          this.$refs.userPhotoDropzone.removeAllFiles();
          alert('저장되었습니다.');
          this.$router.push({ path: '/user' });
        });
      } catch (error) {
        alert(error.response?.data?.message??'error');
        console.log(error);
      }
    },
    resetUser() {
      this.user = _.cloneDeep(this.userInit);
      this.idReadOnly = this.isModify;

      this.approvalClubs = this.user?.clubGroup?.filter(v => v.joinState === 'STATE_APPROVAL')?.map(g => g.groupId) ?? []
      this.approvalDepartment = this.user?.departmentGroup?.filter(v => v.joinState === 'STATE_APPROVAL')?.[0]?.groupId ?? '';

      this.$refs?.userPhotoDropzone?.removeAllFiles();
      this.$refs?.formUser?.resetValidation();
      this.passwordCheck = '';

    }
  },
  created() {
    if(!this.userId) {
      this.title = '회원 추가';
      this.isModify = false;
      this.userInit = _.cloneDeep(this.user);
    } else {
      userApi.get(this.userId).then(user => {
        console.log(user)
        this.user = user;
        this.user.password = '';
        this.user.userHasRoles = (this.user?.userHasRoles ?? []).map(r => r.role.roleId);
        this.approvalClubs = this.user?.clubGroup?.filter(v => v.joinState === 'STATE_APPROVAL')?.map(g => g.groupId) ?? []
        this.approvalDepartment = this.user?.departmentGroup?.filter(v => v.joinState === 'STATE_APPROVAL')?.[0]?.groupId ?? '';
        this.joinDate = user.createdAt.substr(0,10);
        this.joinAt = user.createdAt;
        this.$refs?.userPhotoDropzone?.removeAllFiles();
        

        this.$refs?.formUser?.resetValidation();
        this.passwordCheck = '';
        // this.$refs?.formUser?.reset();

        this.user.originUserId = this.user.userId;
        this.userInit = _.cloneDeep(this.user);

      });

      this.title = '회원정보 수정';
      this.isModify = true;
      this.idReadOnly = true;
      this.user.password = '';
    }


    roleApi.list(true).then(data => {
      this.roles = data;
    });

    groupApi.flatList(1).then(data => {
      this.departmentItems = data;
    });
    groupApi.flatList(2).then(data => {
      this.clubItems = data;
    });

    groupApi.getGroup(1).then(data => {
      this.departmentMeta = data;
    })
    groupApi.getGroup(2).then(data => {
      this.clubMeta = data;
    })

    this.$refs?.userPhotoDropzone?.removeAllFiles();

  }
}
</script>

<style lang="scss">
@import '../../assets/style/layout/variables';

/*.custom-red .v-input--selection-controls__input div {*/
/*  color: red;*/
/*}*/
.dropzone-custom-content {
  /*position: absolute;*/
  /*top: 50%;*/
  /*left: 50%;*/
  /*transform: translate(-50%, -50%);*/
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
}

.dropzone {
  min-height:260px;
  max-height:260px
}

.h2Title {
  @include h2-title;
}

.formInfo {
  @include form-info;
}

.formInfoTxt{
  max-width: 240px;
}

.userDd {
  padding: 10px 0;
}

.list {
  overflow: hidden;
}

.lunar-switch-color:not(.v-input--is-label-active) .v-input--selection-controls__input div {
  color: orange !important;
}
.staff-switch-color:not(.v-input--is-label-active) .v-input--selection-controls__input div {
  color: olivedrab !important;
}

.joinDateHelper{
  height: 100%;
  display: inline-block;
  vertical-align: middle;
}

.joinDate_item{
  display: inline-block;
  vertical-align: middle;
}

</style>